export default __webpack_public_path__ + "static/media/guideToInstantCardhelpMobileHighlight@2x.1ac40e7d.png";